import {
  browserName,
  fullBrowserVersion,
  osName,
  osVersion,
} from "react-device-detect";

const device = {
  device: "web",
  browser: `${browserName} ${fullBrowserVersion}`,
  os: `${osName} ${osVersion}`,
};

export default device;
